import {createFileRoute} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PractitionerRecoverPassword from '@/practitioner/views/practitioner/PractitionerRecoverPassword';

export const Route = createFileRoute(
  '/(practitioner)/practitioners/$practitionerId/recover-password'
)({
  component: PractitionerRecoverPassword,
  beforeLoad: grantUser(practitionerAdminGranted),
  loader: ({params}) => ({
    practitionerId: params.practitionerId
  })
});
